import React, { useState, useEffect } from "react";
// Components
import TaskBox from "./TaskBox";

// Variables
import { StatusTypes } from "../../variables";

const Tasks = ({
  activeProject,
  activeTask,
  onChangeActiveTask,
  showTaskForm,
  setShowTaskForm,
  onFormAction,
  onUpdateProject,
  isLoading,
}) => {
  const [taskName, setTaskName] = useState("");

  useEffect(() => {
    // Reset form
    setTaskName("");
  }, [showTaskForm]);
  useEffect(() => {
    // Reset form
    sortedTasks = activeProject ? [...activeProject._Tasks] : [];
  }, [activeProject]);

  // Add Project Form Classes
  let popupClasses = `absolute ${
    showTaskForm ? "block" : "hidden"
  } top-[60px] right-0 w-[400px]  bg-white dark:bg-primary-dark border-2 border-slate-200 dark:border-indigo-500 text-center rounded-xl shadow-xl dark:shadow-lg dark:shadow-indigo-800 py-3 px-5 `;

  // Sorting
  let sortedTasks = activeProject ? [...activeProject._Tasks] : [];

  const onChangeStatus = (status, task) => {
    let updatedTasks = [
      ...sortedTasks.map((t) => {
        if (t._ID === task._ID) {
          return { ...task, _Status: status };
        } else {
          return t;
        }
      }),
    ];
    // Update project state
    onUpdateProject({ ...activeProject, _Tasks: updatedTasks });
  };

  const filterStatus = (a, b) => {
    switch (a) {
      case StatusTypes.INPROGRESS:
        return false;
        break;
      case StatusTypes.NOTSTARTED:
        if (b === StatusTypes.COMPLETED) return false;
        else return true;
        break;
      case StatusTypes.COMPLETED:
        return true;
        break;

      default:
        break;
    }
  };

  // Put completed last
  sortedTasks.sort(
    (a, b) =>
      filterStatus(a._Status, b._Status) - filterStatus(b._Status, a._Status)
  );

  return (
    <div className="h-full flex flex-col">
      {/* Label + Add button */}
      <div className="relative flex grow-0 justify-between align-center my-4 px-1.5">
        <h1 className="text-4xl">Tasks</h1>
        {activeProject && (
          <button
            onClick={(e) => {
              setShowTaskForm(!showTaskForm);
              e.stopPropagation();
            }}
            className="bg-indigo-500 hover:bg-indigo-600 py-2 px-6 text-white rounded-full "
          >
            Add
          </button>
        )}

        {/* Add project form pop up */}
        <div onClick={(e) => e.stopPropagation()} className={popupClasses}>
          <h2 className="text-2xl mb-5 mt-1">Add task</h2>
          <input
            type="text"
            placeholder="Name"
            value={taskName}
            onChange={(e) => setTaskName(e.target.value)}
            className={`w-full border-2 border-indigo-400 bg-slate-50 px-4 mb-4 rounded-full dark:placeholder-slate-300 text-slate-700 dark:text-white dark:bg-indigo-900`}
          />
          <button
            onClick={!isLoading ? () => onFormAction(taskName) : () => {}}
            className="bg-indigo-500 hover:bg-indigo-600 py-2 px-6 text-white rounded-full mt-2 mb-2 "
          >
            Add
          </button>
        </div>
      </div>
      {/* Tasks */}
      <div className="grow h-full overflow-y-auto pr-4 pl-1.5 mb-4 scrollbar-thin scrollbar-thumb-indigo-500 scrollbar-thumb-rounded">
        {sortedTasks.length !== 0 ? (
          sortedTasks.map((task, idx) => {
            let label;
            let textColor;
            if (idx === 0) {
              label = "In Progress";
              textColor = "teal";
            }else if (task._Status === StatusTypes.NOTSTARTED && sortedTasks[idx-1]._Status === StatusTypes.INPROGRESS){
              label = "Not Started";
              textColor = "orange";
            } else if (task._Status === StatusTypes.COMPLETED && sortedTasks[idx-1]._Status === StatusTypes.NOTSTARTED){
              label = "Completed";
              textColor = "lime";
            }

            return (
              <>
                {label && <h1 className={`text-lg mb-2 text-${textColor}-400`}>{label}</h1>}
                <TaskBox
                  title={task._Title}
                  status={task._Status}
                  timeWorkedOn={task._TimeWorkedOn}
                  active={activeTask && task._ID === activeTask._ID}
                  onChangeActiveTask={() => onChangeActiveTask(task)}
                  onChangeStatus={(status) => onChangeStatus(status, task)}
                />
              </>
            );
          })
        ) : (
          <div className="text-xl flex flex-col items-center justify-center h-full  w-full uppercase text-slate-400 ">
            {activeProject
              ? "There are no tasks in this project"
              : "Select a project to see tasks"}
          </div>
        )}
      </div>
    </div>
  );
};

export default Tasks;
